export const LAUNCH_OFFER_ENDS = new Date("2026-12-31T23:59:59+05:30");
export const LAUNCH_OFFER_LABEL = "Dec 31, 2026";

export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    launchPrice: 59,
    listPrice: 99,
    blurb: "For small teams getting started.",
    highlights: ["1 connected platform", "3 team seats", "Basic governance policies"],
  },
  {
    id: "classic",
    name: "Classic",
    launchPrice: 99,
    listPrice: 149,
    blurb: "For growing governance needs.",
    highlights: ["2 connected platforms", "10 team seats", "SHA-256 audit chain"],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    launchPrice: 149,
    listPrice: 199,
    blurb: "Advanced controls at scale.",
    popular: true,
    highlights: ["3 connected platforms", "EMIE Co-pilot included", "Bring your own LLM"],
  },
  {
    id: "unlimited",
    name: "Custom",
    launchPrice: 199,
    listPrice: 249,
    blurb: "Everything, without limits.",
    highlights: ["Unlimited products", "White-label + own domain", "Click-to-deploy, no source"],
  },
];

export function isLaunchOfferActive(now = new Date()) {
  return now.getTime() <= LAUNCH_OFFER_ENDS.getTime();
}

export function planPrice(plan, now = new Date()) {
  return isLaunchOfferActive(now) ? plan.launchPrice : plan.listPrice;
}

export function planRangeLabel(now = new Date()) {
  const first = PLANS[0];
  const last = PLANS[PLANS.length - 1];
  return `$${planPrice(first, now)}–${planPrice(last, now)}/mo`;
}
